import { OpenItemsTab } from '@/features/Transition360/OpenItemsTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/transition-360/projects/$projectId/assets/$projectAssetId/open-items',
)({
    component: OpenItemsTabRoute,
});

function OpenItemsTabRoute() {
    const { projectId, projectAssetId } = Route.useParams();
    return (
        <OpenItemsTab projectId={projectId} projectAssetId={projectAssetId} />
    );
}
